export default "__VITE_PUBLIC_ASSET__6a511042__"